// extracted by mini-css-extract-plugin
module.exports = {"gradientButton":"GradientButton_gradientButton__mIHK8","btnGrad":"GradientButton_btnGrad__cdcH3"};